<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>查询商品详情图</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    ref="inputRef"
                    v-model="form.dbid"
                    placeholder="打标ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
        </div>
        <div v-for="item in resData" v-if="resData" style="margin-bottom: 0">
          <!--文字-->
          <div align="center" style="margin: 20px 0">
            <span>商品名称：{{ item.goods_name }}&emsp;</span>
            <span>商品货号：{{ item.goods_no }}&emsp;</span>
            <span>颜色：{{ item.co_val }}&emsp;</span>
            <span>尺码：{{ item.si_val }}&emsp;</span>
            <span v-if="item.status_text"
              >状态：{{ item.status_text }}&emsp;</span
            >
          </div>
          <!--图片-->
          <div>
            <img
              v-for="images in item.all_goods_img"
              v-viewer
              :src="images"
              width="19%"
              height="20%"
              style="margin-right: 1%; overflow: hidden; cursor: pointer"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {},
      loading: false,
      tableLoading: false,
      url: "/erp/DaBiaoRecord/getGoodsImages",
      status: "",
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      this.$refs.inputRef.$el.children[0].focus();
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    search() {
      this.form.page = 1;
      this.loading = true;

      if (typeof this.form.dbid != "undefined") {
        var dbid = this.form.dbid.split("dbid=");
      }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (
          typeof this.form.dbid != "undefined" &&
          typeof dbid[1] != "undefined"
        ) {
          this.form.dbid = dbid[1];
        }
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.resData = [];
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/warehousetool/ImagesOfGoods.vue